import React from 'react'
import PropTypes from 'prop-types'
import './button.css'

function Button({ children, large, fullWidth, disabled, onClick, type, className }) {

    const buttonLarge = large ? 'button--large' : ''
    const buttonFullWidth = fullWidth ? 'button--fullWidth' : ''

    const buttonType = type ? `button--${type}` : ''

    function handleClick(e) {
        if (onClick) {
            onClick(e)
        }
    }

    return (
        <button onClick={handleClick} className={`button ${buttonLarge} ${buttonFullWidth} ${buttonType} ${className}`} disabled={disabled}>{ children }</button>
    )
}

Button.propTypes = {
    children: PropTypes.node.isRequired,
}

export default Button


// WEBPACK FOOTER //
// ./src/components/Button/index.js